import { apiUrl } from "@/shared/api/config";

const OBJECTIVE_TYPES = [
  "baron",
  "dragon",
  "fire",
  "water",
  "earth",
  "air",
  "hextech",
  "chemtech",
  "elder",
  "herald",
  "grub",
  "inhibitor",
] as const;

function isObjectiveType(t: string): t is (typeof OBJECTIVE_TYPES)[number] {
  return OBJECTIVE_TYPES.includes(t.toLowerCase() as (typeof OBJECTIVE_TYPES)[number]);
}

export function getObjectiveImageUrl(type: string): string {
  const key = type.toLowerCase();
  const safe = isObjectiveType(key) ? key : "dragon";
  const base = typeof apiUrl !== "undefined" ? apiUrl.replace(/\/$/, "") : "";
  return `${base}/riot/objective/${safe}.png`;
}
